import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';
import EmailVerification from './EmailVerification';

/**
 * Protected Route Component
 * 🔒 Ensures routes are only accessible to authenticated users
 */
const ProtectedRoute = ({ children }) => {
  const { user, isAuthenticated, loading } = useAuthContext();
  const location = useLocation();
  
  console.log('🔒 Protected Route Check:', { 
    isAuthenticated, 
    loading, 
    path: location.pathname,
    token: localStorage.getItem('token') ? 'Present' : 'Missing',
    emailVerified: user?.isEmailVerified,
    userOnboarding: user?.onboarding
  });

  // Show loading state while checking auth
  if (loading) {
    console.log('⌛ Checking authentication...');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('🚫 Access denied: User not authenticated');
    // Save the attempted URL for redirect after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // If authenticated but email not verified, handle based on route
  if (isAuthenticated && user && !user.isEmailVerified) {
    console.log('⚠️ Email verification required');
    
    // Already on the verification page, just show the component
    if (location.pathname === '/verify-email') {
      return <EmailVerification />;
    }
    
    // Trying to access protected resource, redirect to verification
    console.log('🔄 Redirecting to verification page');
    return <Navigate to="/verify-email" replace />;
  }

  // ONBOARDING DISABLED - Skip onboarding check
  if (isAuthenticated && user && user.isEmailVerified) {
    console.log('🚫 Onboarding system is disabled - allowing direct access');
    // Note: Onboarding check has been disabled temporarily
    // Users can still access profile settings to enter their information manually
  }

  console.log('✅ Access granted: User authenticated and verified');
  return children;
};

export default ProtectedRoute; 